<avs-data-point-options
  (changed)="setDatapoint($event)"
  [config]="config()"
  [hideDateRangeInput]="true"
  [showDataType]="true"
  [showFullLocation]="false"
/>

@if (datapoint()) {
  <div [formGroup]="form">
    <mat-card-subtitle class="mb-5">Gauge value range:</mat-card-subtitle>

    <div class="flex flex-row">
      <label class="input-main-label">
        <span class="w-3 h-3 rounded-md bg-ui-green-light inline-block mr-1.5"></span>
        Green range*
      </label>

      <div class="flex flex-row justify-between classic-form-item-wrapper">
        <div class="w-[192px]">
          <mat-form-field
            class="input-classic w-full"
            appearance="outline"
          >
            <input
              id="normalMin"
              type="number"
              formControlName="normalMin"
              matInput
              placeholder="Min"
            />
            <mat-error>Input is not valid</mat-error>
          </mat-form-field>
        </div>
        <div class="w-[192px]">
          <mat-form-field
            class="input-classic w-full"
            appearance="outline"
          >
            <input
              id="normalMax"
              type="number"
              formControlName="normalMax"
              matInput
              placeholder="Max"
            />
            <mat-error>Input is not valid</mat-error>
          </mat-form-field>
        </div>
      </div>
    </div>

    <div class="flex flex-row">
      <label class="input-main-label">
        <span class="w-3 h-3 rounded-md bg-ui-yellow-100 inline-block mr-1.5"></span>
        Yellow range*
      </label>

      <div class="flex flex-row justify-between classic-form-item-wrapper">
        <div class="w-[192px]">
          <mat-form-field
            class="input-classic w-full"
            appearance="outline"
          >
            <input
              id="warningMin"
              type="number"
              formControlName="warningMin"
              matInput
              placeholder="Min"
            />
            <mat-error>Input is not valid</mat-error>
          </mat-form-field>
        </div>
        <div class="w-[192px]">
          <mat-form-field
            class="input-classic w-full"
            appearance="outline"
          >
            <input
              id="warningMax"
              type="number"
              formControlName="warningMax"
              matInput
              placeholder="Max"
            />
            <mat-error>Input is not valid</mat-error>
          </mat-form-field>
        </div>
      </div>
    </div>

    <div class="flex flex-row">
      <label class="input-main-label">
        <span class="w-3 h-3 rounded-md bg-ui-red-50 inline-block mr-1.5"></span>
        Red range*
      </label>

      <div class="flex flex-row justify-between classic-form-item-wrapper">
        <div class="w-[192px]">
          <mat-form-field
            class="input-classic w-full"
            appearance="outline"
          >
            <input
              id="criticalMin"
              type="number"
              formControlName="criticalMin"
              matInput
              placeholder="Min"
            />
            <mat-error>Input is not valid</mat-error>
          </mat-form-field>
        </div>
        <div class="w-[192px]">
          <mat-form-field
            class="input-classic w-full"
            appearance="outline"
          >
            <input
              id="criticalMax"
              type="number"
              formControlName="criticalMax"
              matInput
              placeholder="Max"
            />
            <mat-error>Input is not valid</mat-error>
          </mat-form-field>
        </div>
      </div>
    </div>
  </div>
}
